import {useQuery} from '@apollo/react-hooks';

import type {GetCTABanners as GetCTABannersQuery} from 'nutshell-graphql-types';

import GET_CTA_BANNERS from './graphql/queries/get-cta-banners.graphql';

export const useGetCTABanners = () => {
    const {data, refetch} = useQuery<GetCTABannersQuery, Record<any, any>>(GET_CTA_BANNERS, {
        fetchPolicy: 'cache-and-network',
    });

    const ctaBanners = data ? data.ctaBanners : null;

    return {ctaBanners: ctaBanners ? ctaBanners : [], refetch};
};
